export default class FormFilter {
  static isPhone(rule, value, callback) {
    if (!value) {
      callback(new Error("手机号不能为空"))
    }
    else if (!/^1[345678]\d{9}$/.test(value)) {
      callback(new Error("请输入正确的手机号"))
    } else {
      callback()
    }
  }
  static isNumber(rule, value, callback) {
    if (value && isNaN(value)) {
      callback(new Error("请输入数字"))
    }
    else {
      callback()
    }
  }
  //三位数的数字
  static isThreeNumber(rule, value, callback) {
    if (value && isNaN(value)) {
      callback(new Error("请输入数字"))
    }
    else if (value.length > 3) {
      callback(new Error("请输入正确范围的数字"))
    }
    else {
      callback()
    }
  }
  static isIDCard(rule, value, callback) {
    if (!value) {
      callback(new Error("身份证号不能为空"))
    }
    else if (! /^((\d{15})|(\d{17}(\d|X|x)))$/.test(value)) {
      callback(new Error("请输入正确的身份证号"))
    }
    else {
      callback()
    }
  }
  static bankAccountRule(rule, value, callback) {
    if (!value) {
      callback(new Error("银行账号不能为空"))
    }
    else if (isNaN(value)) {
      callback("请输入数字")
    }
    else {
      callback()
    }
  }
  static isTel(rule, value, callback) {
    if (!value) {
      callback(new Error("座机号不能为空"))
    }
    else if (! /0\d{2,3}-\d{7,8}/.test(value)) {
      callback(new Error("请输入正确的座机号"))
    }
    else {
      callback()
    }
  }
  static notRequiredTel(rule, value, callback) {
    if (!value) {
      callback()
    }
    else if (! /0\d{2,3}-\d{7,8}/.test(value)) {
      callback(new Error("请输入正确的座机号码"))
    }
    else {
      callback()
    }
  }
  static notRerquiredPhone(rule, value, callback) {
    if (!value) {
      callback()
    }
    else if (!/^1[345678]\d{9}$/.test(value)) {
      callback(new Error("请输入正确的手机号"))
    } else {
      callback()
    }
  }
}